export const colors = {
  blue: '#487db9',
  green: '#009688',
  greyBlueDark: '#495867',
  greyLite: '#e8e8e8',
  pink: '#ff0063',
  purple: '#673ab7',
  red: '#e02222',
}
